$(function () {
    if( $(location).attr('hash').length > 1 ){
        $('.popup-container').addClass('active');
        $('.popup-item').removeClass('active');
        $($(location).attr('hash')).addClass('active');
        $('.menu ul li a[href="' + $(location).attr('hash') + '"]').addClass('active');
        $('body').addClass('popup-active');
    }

    $(window).on('hashchange', function(e){
        console.log(location);
        if( $(location).attr('hash').length > 1 ){
            $('body').removeClass('popup-active');
            $('.menu ul li a').removeClass('active');
            //MENU MOBILE
            $('.header .menu').removeClass('active');
            $('.menu-mobile-cont').removeClass('open');
            //
            $('.popup-container').addClass('active');
            $('.popup-item').removeClass('active');
            $($(location).attr('hash')).addClass('active');
            $('.menu ul li a[href="' + $(location).attr('hash') + '"]').addClass('active');
            $('body').addClass('popup-active');
        }
    });

    $('.popup-container .close').click(function(){
        window.location.hash = '';
        $(this).parent().removeClass('active');
        $('.popup-item').removeClass('active');
        $('.menu ul li a').removeClass('active');
        $('body').removeClass('popup-active');
    });
    $('.popup-container .go-back').click(function(){
        window.location.hash = '';
        $(this).parent().removeClass('active');
        $('.popup-item').removeClass('active');
        $('.menu ul li a').removeClass('active');
        $('body').removeClass('popup-active');
    });

    $('ul.proyectos li.items').mouseout(function(){
        $('.images-container img').removeClass('active');
    });

    $('ul.proyectos li.items a.proyecto-link').hover(function(){
        $('.images-container img').removeClass('active');
        $( $(this).data('img') ).addClass('active');
    });


    //MENU MOBILE
    $('.menu-mobile-cont').click(function(){
		$(this).toggleClass('open');
        $('.header .menu').toggleClass('active');
	});

    var imageModalContainer = $('#image-modal-container'),
        imageModalDescriptionContainer = imageModalContainer.find('.description-container'),
        imageModalArrowLeft = imageModalContainer.find('.image-modal-left'),
        imageModalArrowRight = imageModalContainer.find('.image-modal-right'),
        imageIndex = imageModalContainer.find('#image-index'),
        imageTotal = imageModalContainer.find('#image-total'),
        imageBig = imageModalContainer.find('#modal-image'),
        gallery = false,
        currentIndex = false;

    $('#image-modal-close').on('click', (ev) => {
        $('body').removeClass('image-modal-open');
        imageModalContainer.hide();
    });

    imageModalArrowLeft.on('click', ev => {
        if(currentIndex-1 == 1) {
            imageModalArrowLeft.hide();
        }else if(currentIndex-1 < 1){
            return;
        }
        currentIndex--;
        imageModalArrowRight.show();

        var currentTarget = $(gallery[currentIndex-1]);
        var targetImage = currentTarget.find('img');
        imageIndex.html(currentIndex);
        imageModalDescriptionContainer.html(JSON.parse(currentTarget.data('description')));
        imageBig.attr('style', 'background-image:url("'+targetImage.attr('src')+'"').attr('class', targetImage.attr('class'));
    });

    imageModalArrowRight.on('click', ev => {
        if(currentIndex+1 == gallery.length) {
            imageModalArrowRight.hide();
        }else if(currentIndex+1 > gallery.length){
            return;
        }
        currentIndex++;
        imageModalArrowLeft.show();

        var currentTarget = $(gallery[currentIndex-1]);
        var targetImage = currentTarget.find('img');
        imageIndex.html(currentIndex);
        imageModalDescriptionContainer.html(JSON.parse(currentTarget.data('description')));
        imageBig.attr('style', 'background-image:url("'+targetImage.attr('src')+'"').attr('class', targetImage.attr('class'));
    });

    $('.image-modal-trigger').on('click', (ev) => {

        if ($(window).width() > 960) {

            var currentTarget = $(ev.currentTarget),
                targetImage = currentTarget.find('img');
            if(!gallery) {
                gallery = currentTarget.parent().find('.image-modal-trigger');
                imageTotal.html(gallery.length);
            }
            currentIndex = currentTarget.data('index');
            imageModalArrowLeft.show();
            imageModalArrowRight.show();
            if(currentIndex == 1) {
                imageModalArrowLeft.hide();
            }
            else if(currentIndex == gallery.length) {
                imageModalArrowRight.hide();
            }
            imageIndex.html(currentIndex);
            imageBig.attr('style', 'background-image:url("'+targetImage.attr('src')+'"').attr('class', targetImage.attr('class'));
            imageModalDescriptionContainer.html(JSON.parse(currentTarget.data('description')));
            $('body').addClass('image-modal-open');
            imageModalContainer.fadeIn();

        }

    });

    $(document).keydown(function(e) {
        switch(e.which) {
            case 37: // left
                imageModalArrowLeft.trigger( "click" );
            break;

            case 39: // right
                imageModalArrowRight.trigger( "click" );
            break;

            case 27: // down
                $('#image-modal-close').trigger( "click" );
            break;

            default: return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    });

});
